// app/javascript/controllers/image_modal_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "modalImage"]

  connect() {
    // Close modal when clicking outside the image
    this.modalTarget.addEventListener('click', (e) => {
      if (e.target === this.modalTarget) {
        this.close()
      }
    })

    // Close on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modalTarget.classList.contains('block')) {
        this.close()
      }
    })
  }

  open(event) {
    const clickedImage = event.currentTarget
    this.modalImageTarget.src = clickedImage.src
    this.modalImageTarget.alt = clickedImage.alt
    this.modalTarget.classList.remove('hidden')
    this.modalTarget.classList.add('block')
  }

  close() {
    this.modalTarget.classList.remove('block')
    this.modalTarget.classList.add('hidden')
  }
}